module.exports = __webpack_public_path__ + "static/media/photo65.feef51c9.jpg";